// import AdminClientBaseForm from 'components/AdminClientBaseForm';
import { useNavigate } from 'react-router-dom';
import AdminClientBaseForm from '../../../components/AdminClientBaseForm';

const BenchmarkClientNew = () => {
  const navigate = useNavigate();

  const onSuccess = (response) => {
    navigate(`/benchmarks/clients/${response.data.id}`);
  };

  return (
    <AdminClientBaseForm
      url='/admin/benchmarks/clients/'
      entityTitle='Clients'
      onSuccess={onSuccess}
      breadcrumbs={[
        { href: '/benchmarks/clients', label: 'Benchmarks' },
        { href: '/benchmarks/clients', label: 'Clients' },
        {
          label: 'New Client',
        },
      ]}
      description={`Creating a benchmark client`}
      adminClientPage={false}
    />
  );
};

export default BenchmarkClientNew;
